/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * desakita API — permukaan publik
 * Dokumen TURUNAN — JANGAN diedit. Dihasilkan scripts/gen-public-spec.ts dari dist/openapi.bundled.yaml, memuat HANYA operasi ber-`security: []`. Untuk mengubah isinya, ubah kontraknya (openapi/features/*.yaml) lalu daftarkan operationId-nya di openapi/_shared/public-operations.yaml.
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FailureResponse,
  HealthPublicStatistikYearlyResponse,
  SuccessEnvelope
} from '../../model';

import { publicFetch } from '../../../mutator/publicFetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetPublicHealthStatistikYearlyUrl = () => {




  return `/public/health/statistik/yearly`
}

export const getPublicHealthStatistikYearly = async ( options?: RequestInit): Promise<SuccessEnvelope & HealthPublicStatistikYearlyResponse> => {

  return publicFetch<SuccessEnvelope & HealthPublicStatistikYearlyResponse>(getGetPublicHealthStatistikYearlyUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicHealthStatistikYearlyQueryKey = () => {
    return [
    `/public/health/statistik/yearly`
    ] as const;
    }


export const getGetPublicHealthStatistikYearlyQueryOptions = <TData = Awaited<ReturnType<typeof getPublicHealthStatistikYearly>>, TError = FailureResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicHealthStatistikYearly>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicHealthStatistikYearlyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicHealthStatistikYearly>>> = ({ signal }) => getPublicHealthStatistikYearly({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicHealthStatistikYearly>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicHealthStatistikYearlyQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicHealthStatistikYearly>>>
export type GetPublicHealthStatistikYearlyQueryError = FailureResponse


export function useGetPublicHealthStatistikYearly<TData = Awaited<ReturnType<typeof getPublicHealthStatistikYearly>>, TError = FailureResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicHealthStatistikYearly>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicHealthStatistikYearly>>,
          TError,
          Awaited<ReturnType<typeof getPublicHealthStatistikYearly>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicHealthStatistikYearly<TData = Awaited<ReturnType<typeof getPublicHealthStatistikYearly>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicHealthStatistikYearly>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicHealthStatistikYearly>>,
          TError,
          Awaited<ReturnType<typeof getPublicHealthStatistikYearly>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicHealthStatistikYearly<TData = Awaited<ReturnType<typeof getPublicHealthStatistikYearly>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicHealthStatistikYearly>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicHealthStatistikYearly<TData = Awaited<ReturnType<typeof getPublicHealthStatistikYearly>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicHealthStatistikYearly>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicHealthStatistikYearlyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






